import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';

import { ANY_SPORT_MY_CARDS_COLLECTION_COLLECTIONSLUG_CARDS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams';

const CollectionPage = () => {
  const { collectionSlug } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_MY_CARDS_COLLECTION_COLLECTIONSLUG_CARDS,
        {
          params: {
            collectionSlug,
          },
        }
      )}
      replace
    />
  );
};

export default CollectionPage;
